import { render } from "./EnterNewPassword.vue?vue&type=template&id=50e64e89"
import script from "./EnterNewPassword.vue?vue&type=script&lang=js"
export * from "./EnterNewPassword.vue?vue&type=script&lang=js"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__